

const anchor = document.querySelectorAll('.anchor');






(function ($) {

	/*-------------------------------------------
	 smooth scroll
	 -------------------------------------------*/
	$(function () {

		$('a[href^="#"]').click(function () {
			var target = $(this.hash);
			var position = target.offset().top;
			$('body,html').stop().animate({
				scrollTop: position
			}, 0);
			return false;
		});
	});

	// faq
	$('.faq__btn-question').on('click', function () {
		$(this).toggleClass('is-open');
		$(this).parents('.faq__content').find('.faq__answer').slideToggle();
	});


	/*
	 * css swicher
	 */
	function css_browser_selector(u) {
		var ua = u.toLowerCase(),
			is = function (t) {
				return ua.indexOf(t) > -1
			},
			e = 'edge',
			g = 'gecko',
			w = 'webkit',
			s = 'safari',
			o = 'opera',
			m = 'mobile',
			h = document.documentElement,
			b = [
				(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) :
					!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua) ? ('ie ie' + RegExp.$1) :
						is('edge/') ? e :
							is('firefox/2') ? g + ' ff2' :
								is('firefox/3.5') ? g + ' ff3 ff3_5' :
									is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' :
										is('gecko/') ? g :
											is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
												(/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
												is('konqueror') ? 'konqueror' :
													is('blackberry') ? m + ' blackberry' :
														is('android') ? m + ' android' :
															is('chrome') ? w + ' chrome' :
																is('iron') ? w + ' iron' :
																	is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') :
																		is('mozilla/') ? g :
																			'',
				is('j2me') ? m + ' j2me' :
					is('iphone') ? m + ' iphone' :
						is('ipod') ? m + ' ipod' :
							is('ipad') ? m + ' ipad' :
								is('mac') ? 'mac' :
									is('darwin') ? 'mac' :
										is('webtv') ? 'webtv' :
											is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
												is('freebsd') ? 'freebsd' :
													(is('x11') || is('linux')) ? 'linux' :
														'',
				'js'
			];
		c = b.join(' ');
		h.className += ' ' + c;
		return c;
	};
	css_browser_selector(navigator.userAgent);



	/*====================================
	scroll anime
	====================================*/
	$(window).on('scroll', function () {
		const scrollTop = $(this).scrollTop();
		const wh = $(window).height();

		$('.js-anime').each(function () {
			if (scrollTop > $(this).offset().top - wh + wh / 4) {
				$(this).addClass('js-animeOn');
			}
		});

		$('.js-move').each(function () {
			if (scrollTop > $(this).offset().top - wh + wh / 2) {
				$(this).addClass('js-animeOn');
			}
		});
		const voiceContent = document.querySelector('.voice__content');
		const rect = voiceContent.getBoundingClientRect();
		const rect01 = block01.getBoundingClientRect();
		const rect02 = block02.getBoundingClientRect();
		const rect03 = block03.getBoundingClientRect();
		const offsetTop = rect.top;
		const offsetBottom = rect.bottom - window.innerHeight;
		const offsetTop01 = rect01.top;
		const offsetTop02 = rect02.top;
		const offsetTop03 = rect03.top;
		if (offsetTop < 0 && 0 < offsetBottom) {
			block01.classList.add('is-fixed');
			block02.classList.add('is-fixed');
			block03.classList.add('is-fixed');
		} else {
			block01.classList.remove('is-fixed');
			block02.classList.remove('is-fixed');
			block03.classList.remove('is-fixed');

		}
		let timingAdjust = window.matchMedia('(min-width: 769px)').matches ? 0 : 200;
		if (offsetTop01 <= timingAdjust) {
			block01.classList.add('is-move');
		}
		if (offsetTop02 <= 0) {
			block02.classList.add('is-show');
			block02.classList.add('is-move');

		} else {
			block02.classList.remove('is-show');

		}
		if (offsetTop03 <= 0) {
			block03.classList.add('is-show');
			block03.classList.add('is-move');

		} else {
			block03.classList.remove('is-show');

		}
	});


	const block01 = document.getElementById('block01');
	const block02 = document.getElementById('block02');
	const block03 = document.getElementById('block03');


})(jQuery);